import { Alert, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { WeighInItem } from '@type/db-types';
import { readableDateTimeFromDate } from '@utils/date-utils';

interface Props {
    item: WeighInItem;
    index: number;
}

export default function WeighInAtEntry({ item: weighInAt, index }: Props) {
    return (
        <Alert severity="info">
            <Typography>Weigh In Location {index === 0 ? '' : `#${index + 1}`}</Typography>
            <Divider sx={{ marginY: 1 }} />
            <Grid container spacing={2} alignItems={'center'}>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle2">
                        Weigh Ins Start:{' '}
                        <Typography>
                            {readableDateTimeFromDate(weighInAt.weighInAtDateTime)}
                        </Typography>
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle2">
                        Location: <Typography>{weighInAt.location.replace(', USA', '')}</Typography>
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    {weighInAt.note ? (
                        <Typography fontStyle="italic" variant="subtitle2">
                            Note: {weighInAt.note}
                        </Typography>
                    ) : null}
                </Grid>
                {/* <Grid size={{ xs: 12 }}>
                    {weighInAt.placeId ? (<MapPreview placeId={weighInAt.placeId} /> 
                    ) : null}
                </Grid> */}
            </Grid>
        </Alert>
    );
}
